<div class="notification-bar d-flex justify-content-between"
     [class.warning]="status === 'warning'"
     [class.info]="status === 'info'">
    <div class="mr-0 ml-auto align-self-center">
        <span class="fa fa-exclamation-triangle fa-lg px-3"></span>
    </div>
    <div class="mx-0 align-self-center px-3 my-3 border-left"
         [class.border-right]="isAdmin">
        <span class="notification-body align-self-center">
            <strong class="d-block text-center">{{ headerText }}</strong>
            <span class="d-block text-center">{{ messageText }}</span>
        </span>
    </div>
    <div class="ml-0 pl-2 mr-auto align-self-center">
        <app-button *ngIf="isAdmin"
                    type="link"
                    (onClick)="onAction.emit()">{{ actionText }}</app-button>
    </div>
</div>
